export const isEventInFuture = (start: string) => {
  const startAsDate = new Date(start)
  return startAsDate > new Date()
}
